import { Component } from "@angular/core"
import { EduComponent } from "../../utils/eduComponent"
import { JoinedRoster } from "../../models/student-site/joined-roster.model"
import { UserService } from "../../services/user.service"
import { ModalService } from "../../shared-components/modal/modal.service"
import { LeaveRosterModalComponent } from "../../shared-components/modals/leave-roster-modal/leave-roster-modal.component"
import { redirectToError } from "../../utils/error-handling"
import { PBSLM_TITLE } from "../../models/constants"
import { ActivatedRoute, NavigationEnd, Params, Router } from "@angular/router"
import { NotificationsService } from "angular2-notifications"
import { GTMService } from "../../services/gtm.service"
import { Title } from "@angular/platform-browser"
import { Location } from "@angular/common"
import { JoinRosterModalComponent } from "../../shared-components/modals/join-roster-modal/join-roster-modal.component"
import Utils from "../../utils/utils"

@Component({
    selector: "app-student-classes",
    templateUrl: "./student-classes.component.html",
    styleUrls: ["./student-classes.component.scss"],
    host: { class: "gtmpage-student-classes" },
})
export class StudentClassesComponent extends EduComponent {
    public classes: JoinedRoster[] = []
    public rosterCode = ""

    constructor(
        private userService: UserService,
        private modalService: ModalService,
        private route: ActivatedRoute,
        private notificationService: NotificationsService,
        private router: Router,
        private gtmService: GTMService,
        private titleService: Title,
        private location: Location
    ) {
        super()
        this.titleService.setTitle(PBSLM_TITLE)
        this.gtmService.resetDataLayer()
        this.gtmService.pushPageView()
        this.addSub(
            this.route.params.subscribe((params: Params) => {
                //router.snapshot.queryParams?.student check added in order to avoid duplication of modal opening
                //for join roster modal - provided link from teacher classes does not contain query
                //param and when the link is inserted in browser an redirect is fired
                if (params.rosterCode && route.snapshot.queryParams?.student) {
                    this.joinClass(params.rosterCode)
                }
            })
        )
        this.addSub(
            this.router.events.subscribe((e: any) => {
                if (e instanceof NavigationEnd) {
                    // We want this to work and reload data on onSameUrlNavigation
                    this.initializeData()
                }
            })
        )
    }

    private initializeData() {
        const data = this.route.snapshot.data.classes
        if (!data) {
            this.classes = []
        } else if (data.error) {
            redirectToError(this.router, this.location, data.error.status)
        } else {
            this.classes = data.classes
        }
    }

    public submitJoinClass($event, rosterCodeInput) {
        $event.preventDefault()
        if (rosterCodeInput.invalid) {
            return
        }
        this.joinClass(rosterCodeInput.value)
    }

    private joinClass(code) {
        this.userService.fetchClassDetails(code).subscribe(
            (classDetails: any) =>
                this.modalService.open(JoinRosterModalComponent, {
                    data: {
                        rostercode: code,
                        classInvitation: classDetails.teacher_name + "'s - " + classDetails.name,
                        classId: classDetails.id,
                    },
                }),
            () => {
                this.notificationService.error(
                    "Uh oh!",
                    "Invalid class code.",
                    Utils.alertConfiguration
                )
            }
        )
    }

    public leaveClass($event, roster: JoinedRoster) {
        $event.preventDefault()
        this.modalService.open(LeaveRosterModalComponent, {
            data: {
                roster: roster,
                classDetails: roster.teacherName + "'s - " + roster.rosterName,
            },
        })
    }
}
